module.exports = __webpack_public_path__ + "static/img/14.ce1ce22.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/eng/14.png
// module id = Ji8y
// module chunks = 0